import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../../components/ui";
import { deslocarCompetencia, nomeCompetencia } from "./pontoUtils";

const SeletorCompetencia = ({ competencia, onChange }) => (
  <div className="flex items-center gap-2">
    <Button
      variant="ghost"
      size="sm"
      icon={ChevronLeft}
      aria-label="Mês anterior"
      onClick={() => onChange(deslocarCompetencia(competencia, -1))}
    />
    <span className="min-w-[140px] text-center text-sm font-semibold text-gray-800">
      {nomeCompetencia(competencia)}
    </span>
    <Button
      variant="ghost"
      size="sm"
      icon={ChevronRight}
      aria-label="Próximo mês"
      onClick={() => onChange(deslocarCompetencia(competencia, 1))}
    />
  </div>
);

export default SeletorCompetencia;
